/**
 * Table column configuration — single source of truth for column behavior.
 *
 * Column properties:
 *   key          – Data field name (used as sort key unless getValue is set)
 *   label        – Display header text
 *   type         – "string" | "number" | "enum"
 *   sortable     – Whether the column supports sorting
 *   filterable   – Whether the column supports filtering
 *   filterType   – "text" | "select" (only when filterable: true)
 *   valueMap     – Maps raw value → display label (enum columns); used for sorting & display
 *   filterOptions – Static filter dropdown options [{ value, label }]. Omit for dynamic options.
 *   getValue     – (row) => value accessor for computed / derived columns
 *   align        – Column text alignment ("left" | "right"), defaults to "left"
 */

// ── External API Table ──────────────────────────────────────────────

export const externalApiTableConfig = {
  defaultSort: { key: "name", order: "ASC" },
  columns: [
    {
      key: "name",
      label: "API Name",
      type: "string",
      sortable: true,
      filterable: true,
      filterType: "text",
    },
    {
      key: "externalApiTypeId",
      label: "API Type",
      type: "enum",
      sortable: true,
      filterable: true,
      filterType: "select",
      valueMap: { 1: "Data", 2: "Stopwatch", 3: "Numeric", 4: "Enum" },
    },
    {
      key: "externalApiEnumBehaviorTypeId",
      label: "Behavior",
      type: "enum",
      sortable: true,
      filterable: true,
      filterType: "select",
      valueMap: { 1: "Anchor", 2: "Sticky" },
      filterOptions: [
        { value: "none", label: "None" },
        { value: 1, label: "Anchor" },
        { value: 2, label: "Sticky" },
      ],
    },
    {
      key: "description",
      label: "API Description",
      type: "string",
      sortable: true,
      filterable: false,
    },
    {
      key: "companyName",
      label: "Company",
      type: "string",
      sortable: true,
      filterable: true,
      filterType: "select",
    },
    {
      key: "implementations",
      label: "Implementations",
      type: "number",
      sortable: true,
      filterable: false,
      getValue: (row) => (row.registrationPoints ? row.registrationPoints.length : 0),
      align: "right",
    },
  ],
};
